/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const JaneGold24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Jane Gold 24">
      <circle cx={12} cy={12} r={12} fill="#FFC220" className="Fill-Main" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M19 12a.539.539 0 0 1-.538.539 5.923 5.923 0 0 0-5.923 5.923.539.539 0 0 1-1.078 0 5.923 5.923 0 0 0-5.923-5.923.538.538 0 0 1 0-1.078 5.923 5.923 0 0 0 5.923-5.923.538.538 0 0 1 1.078 0 5.923 5.923 0 0 0 5.923 5.923c.297 0 .538.242.538.539Z"
        className="Fill-Accent Details"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: JaneGold24,
  md: JaneGold24,
  lg: JaneGold24,
  xl: JaneGold24,
  xxl: JaneGold24,
  xxxl: JaneGold24,
};

export const JaneGoldIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'jane-gold-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
